import { SUCCESS, REQUEST, ERROR } from './types'

const state = {
  data: {
    cpf: {},
  },
  loading: false,
  error: false,
}

const getters = {
  cpf: (state) => state.data.cpf,
  loading: (state) => state.loading,
  error: (state) => state.error,
}

const actions = {
  async setCheck(context, { key, value }) {
    try {
      context.commit(REQUEST)

      const response = await context.dispatch(
        `api`,
        {
          entity: `checks`,
          action: `get`,
          query: `?cpf=${value}`,
        },
        { root: true }
      )

      if (response.status !== 200) throw response

      const { data } = response

      context.commit(SUCCESS, { key, payload: data })
    } catch (err) {
      console.error(err)
      context.commit(ERROR)
    }
  },
}

const mutations = {
  [REQUEST](state) {
    state.loading = true
  },
  [SUCCESS](state, { key, payload }) {
    state.data[key] = payload
    state.loading = false
    state.error = false
  },
  [ERROR](state) {
    state.error = true
    state.loading = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
